import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { RideCards } from "@app/components";
import { Stack, useTheme } from "@mui/material";
import { slideData } from "../slideData";
import { useNavigate } from "react-router-dom";

interface data {
  title: string;
  compareLabels: string;
  yourRide: string;
  subtitle: string;
  description: string;
  buttonLabel: string;
  image: string;
  path?: string;
  isOuterRefrence?: any;
}

const RideSlider = ({ DialogBoxPopUp }: any) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3500,
    variableWidth: false,
    adaptiveHeight: true,
  };

  return (
    <>
      <Stack
        sx={{
          width: "100%",
          "& .slick-slider": {
            overflow: "visible",
          },
          "& .slick-track": {
            display: "flex",
            alignItems: "stretch",
          },
          "& .slick-slide": {
            height: "auto",
            "& > div": {
              height: "100%",
            },
          },
          "& .slick-dots": {
            bottom: "20px",
            "& li button:before": {
              color: theme.palette.common.black,
              fontSize: "12px",
            },
            "& li.slick-active button:before": {
              color: theme.palette.primary.main,
              opacity: 1,
            },
          },
        }}
      >
        <Slider {...settings}>
          {slideData?.map((data: data, index) => (
            <Stack
              sx={{
                display: "flex !important",
                width: "100%",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <RideCards
                key={index}
                title={`${data?.title},`}
                compareLabels={data?.compareLabels}
                yourRide={data?.yourRide}
                subtitle={data?.subtitle}
                description={data?.description}
                buttonLabel={data?.buttonLabel}
                image={data?.image}
                onClick={() => {
                  if (data?.path) {
                    if (data?.isOuterRefrence) {
                      window.location.href = data?.path;
                    } else {
                      navigate(data.path);
                    }
                  } else {
                    DialogBoxPopUp.show();
                  }
                }}
              />
            </Stack>
          ))}
        </Slider>
      </Stack>
    </>
  );
};

export { RideSlider };
